import { MetricCard } from '@/shared/ui/MetricCard';
import patterns from '@/shared/ui/styles/patterns.module.css';
import { useCaptureSummary } from '../hooks/useCaptureSummary';

export function CaptureStats() {
  const { data } = useCaptureSummary();
  const summary = data?.data;

  function fmt(n: number | null | undefined): string {
    return n == null ? '—' : String(n);
  }

  return (
    <div className={patterns.statGrid4}>
      <MetricCard
        title="Scans (30 days)"
        value={fmt(summary?.sent30d)}
        sub="QR scans from patients"
      />
      <MetricCard title="Opened" value={fmt(summary?.opened)} sub="of these scans" />
      <MetricCard
        title="Reviews completed"
        value={fmt(summary?.completed)}
        sub="from these scans"
      />
      <MetricCard
        title="Completion rate"
        value={summary?.completionRate != null ? `${summary.completionRate}%` : '—'}
        sub="scans → posted review"
      />
    </div>
  );
}
